import { Button, Modal } from 'react-bootstrap';
import { withTheme } from 'styled-components';

import TdasLogoV2 from '../../../assets/svg/tdas-v2.svg';
import { StyledLinkButton, StyledModalHeader } from '../../Styled';

const Connect = ({ onNext, onHide, theme }) => (
  <>
    <StyledModalHeader background={theme.colors.gradients.secondary} closeButton>
      <img src={TdasLogoV2} alt="Turn Down and Save" />
    </StyledModalHeader>
    <Modal.Body className="px-4 pb-3">
      <h1 className="mb-4 text-left">Connect {theme.language.appName} to your smart meter</h1>
      <p className="mb-4">
        Before we can sign you up to Turn Down and Save, {theme.language.appName} needs to connect to your smart meter.
      </p>
      <Button onClick={onNext} block>
        Connect smart meter
      </Button>
      <StyledLinkButton className="mt-3" variant="link" onClick={onHide} block>
        I'll do this later
      </StyledLinkButton>
    </Modal.Body>
  </>
);
export default withTheme(Connect);
